<template>
  <b-card
    v-if="data"
    class="earnings-card"
  >
    <b-row>
      <b-col cols="6">
        <b-card-title class="mb-1">
          <!-- <feather-icon
            icon="CloudRainIcon"
            size="33"
            :class="'text-primary'"
          /> -->
             <img src = "@/assets/icons/rain-svgrepo-com.svg"  width="30"  class="my-svg-alternatex"  alt=""/>
          {{$t('Rain statistics')}}
        </b-card-title>



       <div class="font-small-2">
         <feather-icon
            icon="CircleIcon"
            size="16"
            :class="'text-primary'"
          />
          {{$t('Planned')}} :  {{data.Planned}}
        </div>

         <div class="font-small-2">
           <feather-icon
            icon="CircleIcon"
            size="16"
            :class="'text-primary'"
          />
          {{$t('Served')}} :  {{data.Served}}
        </div>
          

        <!-- <b-card-text class="text-muted font-small-2">
          <span class="font-weight-bolder">68.2%</span><span> more earnings than last month.</span>
        </b-card-text> -->
      </b-col>
      
      <b-col cols="6" class="pull-right">
        <!-- chart -->
       
        <vue-apex-charts
          height="120"
          ref="rainRef"
          :options="earningsChart.chartOptions"
          :series="[data.completion==undefined?0:data.completion
          
          ,data.completion==undefined?1:100-data.completion
          ]"
        />

      </b-col>
    </b-row>

    <b-row>
   <hr width="100%"/>
      <b-col cols="12" v-if="data.Contracts!=undefined">
        <services-chart :widgetLabels="{planned:'service count planed',served:'service count served',complection:'service count complection'}"  
                    :barSeries="data.Contracts.series" title='Rian Data'
                    :labels_data="data.Contracts.categories" :other_data="[]" 
                    :listData="data.Contracts.lists!=undefined?data.Contracts.lists:[]" 
                    />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
 import ServicesChart from '@/views/dashboard/services/ServicesChart'
import {
  BCard, BRow, BCol, BCardTitle, BCardText,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

const $earningsStrokeColor2 = '#28c76f66'
const $earningsStrokeColor3 = '#28c76f33'
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BCardTitle,
    BCardText,
    VueApexCharts,
    ServicesChart
  },
  watch: {
    '$store.state.appConfig.layout.isRTL': function (newVal, oldVal) {
      if(this.$refs.rainRef!=undefined){
         this.$refs.rainRef.updateOptions({
          plotOptions:{pie:{donut:{labels:{total:{label:this.$t('Served')}}}}}
        });
      }
    }
    },
  props:{

    data: {
      type: Object,
      default: () => {},
    },
     chartsData:{
      type: Array,
      default:()=>{}

    }
  },

  
  computed:{

    getSeriesArray(){
      var serarr=[];
        serarr[0]=22;
      return serarr;
    }
  },

  data() {
    return {
      earningsChart: {
        chartOptions: {
          chart: {
            type: 'donut',
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          comparedResult: [2, -3, 8],
          labels: [this.$t('Served'), this.$t('Not Served')],
          stroke: { width: 0 },
         // colors: [$earningsStrokeColor2, $earningsStrokeColor3, $themeColors.success],
           colors: [$themeColors.primary, $themeColors.warning, $themeColors.danger],
          grid: {
            padding: {
              right: -20,
              bottom: -8,
              left: -20,
            },
          },
          plotOptions: {
            pie: {
              //startAngle: -10,
              donut: {
                labels: {
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}%`
                    },
                  },
                  total: {
                    show: true,
                    offsetY: 15,
                    label: this.$t('Served'),
                    formatter(w) {
                      return `${ w.globals.seriesTotals[0]}%`;
                    },
                  },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 1325,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
            {
              breakpoint: 1045,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
          ],
        },
      },
    }
  },
}
</script>
